<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <h2>JAPP</h2>
    <h3>&copy; By JENIA Software</h3>
    <p>client version : {{app?.version}}</p>
    <p>server version : {{server?.implementationVersion}}</p>
  </mat-card-content>
</mat-card>